import { createEntityAdapter } from '@reduxjs/toolkit';
import { IJoinRequest } from '@wix/social-groups-serverless/dist/groups/types';

import type { IRootState } from '../types';

import type { IGroupMember } from './types';

export const membersAdapter = createEntityAdapter<IGroupMember>({
  selectId: (member) => member.contactId as string,
  // disabled due to broken sorting in API
  // sortComparer: (a, b) => a.name.localeCompare(b.name),
});

export const joinRequestsAdapter = createEntityAdapter<IJoinRequest>({
  selectId: (request) => request.profile.siteMemberId as string,
});

export const selectors = membersAdapter.getSelectors<IRootState>(
  (state) => state.members,
);
